import { UtilitySync } from './utility-sync.page';

export { UtilitySync };
